import { SapEtaOriginEnum } from '../constants/sap-eta-origin';
import { SapEtaScenarioEnum } from '../constants/sap-eta-scenario';

export class SapEtaItemModel {
  id: number | null = null;
  sapId: string | null = null;
  allowedCarriers: string[] = [];
  statusOrigin: SapEtaOriginEnum | null = null;
  consignors: string[] = [];
  consignees: string[] = [];
  scenario: SapEtaScenarioEnum | null = null;
  deviationToleranceHours: number | null = null;
  transportPrefix: string | null = null;
}
